module.exports = __webpack_public_path__ + "static/img/solve18.89e1eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve18.svg
// module id = bI5O
// module chunks = 0